import { LegalLinks } from '../components/layout/LegalLinks';
import { policy } from '../assets/policy.html';

export const PrivacyPolicy = () => (
  <div className="mb-16 lg:mb-6">
    <div
      className="selectable prose prose-lg m-auto w-full max-w-[1080px] p-[60px] opacity-80 md:p-[80px]"
      dangerouslySetInnerHTML={{ __html: policy }}
    />
    <LegalLinks />
  </div>
);
